export const selectYear = <T>(searchValue: number | string, targetKey: string) => (element: T) => {
  if (!searchValue || !targetKey || !element[targetKey as keyof T] || element[targetKey as keyof T] as string === '-') return true;
  const year = new Date(element[targetKey as keyof T] as string).getUTCFullYear()

  return year === searchValue
}